module.exports = __webpack_public_path__ + "img/landing-page.f0334aab.jpg";